import Vue from "vue";

import cpf from "./cpf";
import cnpj from "./cnpj";
import pretty_json from "./pretty_json";
import camel_case from "./camel_case";
import format_date from "./format_date";
import humanize_date from "./humanize_date";
import humanize_datetime from "./humanize_datetime";
import format_datetime from "./format_datetime";
import number_format from "./number_format";
import telefone from "./telefone";
import letra from "./letra";

import vueFilterPrettyBytes from "vue-filter-pretty-bytes";

Vue.filter("cpf", cpf);
Vue.filter("cnpj", cnpj);
Vue.filter("pretty_json", pretty_json);
Vue.filter("camel_case", camel_case);
Vue.filter("format_date", format_date);
Vue.filter("humanize_date", humanize_date);
Vue.filter("humanize_datetime", humanize_datetime);
Vue.filter("format_datetime", format_datetime);
Vue.filter("number_format", number_format);
Vue.filter("telefone", telefone);
Vue.filter("letra", letra);
Vue.use(vueFilterPrettyBytes);
